import { ComponentAPI } from '@philips-emr/tws-core';
import { isEnumValid } from '@philips-emr/tws-utils';

import { LayoutGap } from '../layout';

class DashboardAPI extends ComponentAPI {

  getClassName(): string {
    return this.state.className;
  }

  setClassName(className: string): void {
    this.setState({ className });
  }

  getRowGap(): LayoutGap {
    return this.state.rowGap;
  }

  setRowGap(rowGap: LayoutGap): void {
    if (isEnumValid(LayoutGap, rowGap)) {
      this.setState({ rowGap });
    }
  }

  getColumnGap(): LayoutGap {
    return this.state.columnGap;
  }

  setColumnGap(columnGap: LayoutGap): void {
    if (isEnumValid(LayoutGap, columnGap)) {
      this.setState({ columnGap });
    }
  }
}

export default DashboardAPI;
